import { withStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import LaunchpadIcon from "../../Common/Icons/launchpad/LaunchpadIcon";
import {getLaunchpadKeysLabel} from '../../../../utils/launchpadNavigation/launchpadUtils'
import { hexToRGB } from '../../../../utils/hexToRGB';
import withErrorCatcher from '../../Common/withErrorCatcher';

const styles = theme => {
    const whiteOpacity016 = hexToRGB('#FFFFFF', 0.16)
return ({
    launchpadButton: { 
        margin: 0,
        paddingRight: 0,
        paddingLeft: 0,
        marginRight: 20,
        "&:hover": {
            backgroundColor: 'inherit',
          },
      
    },

    launchpadIconContainer: {
        height: 28,
        borderRadius: 16,
        "&:hover": {
            backgroundColor: whiteOpacity016,
          },
    }
})
}

class LaunchpadToolbar extends PureComponent {

    onClick = (e) => {
        const { dispatch } = this.props;
        dispatch({type: 'TOGGLE_LAUNCHPAD'})
    }

    onKeyUp = (e) => {
        if(e.which === 13){ 
            e.preventDefault();
            return false
        }
    }

    render() {
        const { classes, t, isFocused } = this.props;
        const keyLabel = getLaunchpadKeysLabel()
        return (
            <Tooltip title={`${t('Launchpad')} ${!!keyLabel ? '(' + keyLabel + ')' : ""}`} placement="bottom">
                <IconButton data-intrcm-id="LaunchpadToolbar_0ee11k8h" onKeyPress={this.onKeyUp} classes={{ label: classes.launchpadIconContainer, root: classes.launchpadButton }} aria-label="Launchpad" onClick={this.onClick}>
                    <LaunchpadIcon isFocused={isFocused} />
                </IconButton>
            </Tooltip>

        )
    }
}

const mapStateToProps = (state) => ({
    isFocused: state.launchpadNavigation.isFocused,
})

const mapDispatchToProps = dispatch => ({
    dispatch
})

export default compose(
    withErrorCatcher('Launchpad crashed'),
    withStyles(styles),
    withTranslation('feedToolbar'),
    connect(mapStateToProps, mapDispatchToProps)
)(LaunchpadToolbar);